import { Chip } from "@heroui/react";
import { useTranslation } from "react-i18next";

function DoNotApplyNChip() {
    const { t } = useTranslation();
    return (
        <Chip
            classNames={{
                base: "bg-green-100 font-bold",
                content: "font-bold text-green-700",
            }}
            radius="sm"
            size="sm"
        >
            {t("do_not_apply_n", {
                ns: "fields-list",
            })}
        </Chip>
    );
}

export default DoNotApplyNChip;
